"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var productApi = exports.productApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/product",
      params: params
    });
  },
  findOne: function findOne(id) {
    return (0, _request.default)({
      url: "/product/".concat(id)
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/product",
      data: data,
      method: "post"
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/product/".concat(id, "/update"),
      data: data,
      method: "post"
    });
  },
  addImage: function addImage(id, data) {
    return (0, _request.default)({
      url: "/product/".concat(id, "/image/add"),
      data: data,
      method: "post"
    });
  },
  orderHistory: function orderHistory(id, params) {
    return (0, _request.default)({
      url: "/product/".concat(id, "/orderDetail"),
      params: params
    });
  },
  remove: function remove(id) {
    return (0, _request.default)({
      url: "/product/".concat(id, "/delete"),
      method: "post"
    });
  },
  findRates: function findRates(id, params) {
    return (0, _request.default)({
      url: "/product/".concat(id, "/rates"),
      params: params
    });
  },
  findConsigns: function findConsigns(params) {
    return (0, _request.default)({
      url: "/product/consigns",
      params: params
    });
  }
};